var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTwitter = function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 50 50"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 49,
    x: 0.5,
    y: 0.5,
    stroke: "#fff",
    rx: 24.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M30.725 16h3.054l-6.672 7.624L34.957 34h-6.145l-4.816-6.291L18.493 34h-3.06l7.136-8.156L15.044 16h6.3l4.348 5.75zm-1.073 16.174h1.691l-10.92-14.443h-1.818z"
  })));
};
export default SvgTwitter;